<div 
  class="modal-backdrop"
  [class.animated]="ShouldFadeInAndOut()"
  [class.shown]="IsShown()"
  [class.closing]="ShouldFadeInAndOut() && IsClosing() ? true : false"
  [class.medium]="Size() === 'medium'"
  [class.large]="Size() === 'large'"
  [class.full]="Size() === 'full'"
  (animationend)="OnAnimationEnded($event)"
  (mousedown)="OnMouseDown($event)"
  (mouseup)="OnMouseUp($event)"
  (touchstart)="OnTouchStart($event)"
  (touchend)="OnTouchEnd($event)"
  tabindex="-1"
  >
  <div class="modal-dialog">
    <div class="modal">
      <ng-content></ng-content>
      <ng-container *ngTemplateOutlet="Contents() ?? null; context: ContentsContext()"></ng-container>
    </div>
  </div>
</div>